import { isEmpty as lisEmpty, replace as lreplace } from 'lodash/fp';

export const certStatusLabel = (a: string | undefined) =>
  lisEmpty(a) ? void 0 : lreplace(/_/g, ' ')(a);
